import type { Config } from '@/core/types'
import { FeatureFlags } from '@/services/types'

type ProdConfig = Omit<Config, 'toolbar'>

export type CoreUrlsConfig = {
  appUrl: string
  apiUrl: string
  socketUrl: string
}

const getConfig = (envSource = import.meta.env): ProdConfig => ({
  env: 'prod',
  appUrl: envSource.VUE_APP_APP_URL,
  apiUrl: envSource.VUE_APP_API_URL,
  telemetryUrl: envSource.VUE_APP_TELEMETRY_URL,
  socketUrl: envSource.VUE_APP_WIRE_URL,
  logger: {
    enabled: false,
    loggerRules: {},
    channels: {},
  },
  sentry: {
    dsn: envSource.VUE_APP_SENTRY_DSN ?? '',
    timeout: Number(envSource.VUE_APP_SENTRY_TIMEOUT) || 2000,
    maskSelectors: ['input[name=password]'],
    unMaskSelectors: ['*'],
  },
  monitoring: {
    key: envSource.VUE_APP_MONITORING_KEY,
  },
  tracking: {
    forceTracking: Boolean(envSource.VUE_APP_FORCE_TRACKING),
    trackSignUp: envSource.VUE_APP_TRACK_SIGN_UP === 'true',
    zendeskKey: envSource.VUE_APP_ZENDESK_KEY,
    googleAnalyticsMeasurementKey: envSource.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_KEY,
    firstPromoterId: envSource.VUE_APP_FIRST_PROMOTER_ID,
    firstPromoterHost: envSource.VUE_APP_FIRST_PROMOTER_HOST,
    postHogUrl: envSource.VUE_APP_POSTHOG_URL,
    postHogKey: envSource.VUE_APP_POSTHOG_KEY,
  },
  featureFlags: {
    [FeatureFlags.Tickets]: envSource.VUE_APP_TICKETS === 'true',
    [FeatureFlags.TicketsNotifications]: envSource.VUE_APP_TICKETS_NOTIFICATION === 'true',
    [FeatureFlags.Tasks]: envSource.VUE_APP_TASKS === 'true',
    [FeatureFlags.Deals]: envSource.VUE_APP_DEALS === 'true',
    [FeatureFlags.ChatsUseCache]: envSource.VUE_APP_CHATS_USE_CACHE === 'true',
    [FeatureFlags.Instagram]: envSource.VUE_APP_INSTAGRAM === 'true',
    [FeatureFlags.CampaignsEmail]: envSource.VUE_APP_CAMPAIGNS_EMAIL === 'true',
    [FeatureFlags.ComposeEmailPromoModal]: envSource.VUE_APP_COMPOSE_EMAIL_PROMO_MODAL === 'true',
    [FeatureFlags.EmailTemplatesTable]: envSource.VUE_APP_EMAIL_TEMPLATES === 'true',
    [FeatureFlags.ImportEmailCleanup]: envSource.VUE_APP_IMPORT_EMAIL_CLEANUP === 'true',
    [FeatureFlags.StripoEditor]: envSource.VUE_APP_STRIPO_EDITOR === 'true',
    [FeatureFlags.EmailFollowUp]: envSource.VUE_APP_EMAIL_FOLLOW_UP === 'true',
    // [FeatureFlags.Automations]: envSource.VUE_APP_AUTOMATIONS === 'true',
    [FeatureFlags.ReviewEmailWithAi]: envSource.VUE_APP_REVIEW_EMAIL_WITH_AI === 'true',
    [FeatureFlags.EmailBonus]: envSource.VUE_APP_EMAIL_BONUS === 'true',
    [FeatureFlags.EntriDomainPurchase]: envSource.VUE_APP_ENTRI_DOMAIN_PURCHASE === 'true',
  },
})

export default getConfig
